var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.estilo,attrs:{"role":"alert"}},[_vm._t("default"),(_vm.fechavel)?_c('button',{staticClass:"close",attrs:{"type":"button","aria-label":"Close"},on:{"click":_vm.fechar}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }